// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  active: boolean,
  removing: boolean,
  handleChange: () => void
};

type ComposedProps = Props & WithI18nProps;

class NoInstalledThemesModal extends Component<ComposedProps> {
  render() {
    const { i18n, active } = this.props;

    return (
      <Modal
        open={active}
        onClose={this.handleChange}
        title={i18n.translate('AdminHTML.Integration.NoInstalledThemes.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Integration.NoInstalledThemes.actionGoToThemeSetup'),
          onAction: () => {
            history.push(routes.themeSetup.view());
          }
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleChange
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <TextStyle>
              {i18n.translate('AdminHTML.Integration.NoInstalledThemes.content', {
                t: (
                  <Button plain onClick={() => history.push(routes.themeSetup.view())}>
                    {i18n.translate('AdminHTML.Integration.NoInstalledThemes.content_t')}
                  </Button>
                )
              })}
            </TextStyle>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChange();
  };
}

export default withI18n()(NoInstalledThemesModal);
